
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import firebase from "../../firebase/FirebaseProvider";
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';

import { isPasswordValid } from '../../utils/regex'
import './password_reset_handler.css';

class PasswordResetHandler extends Component {
    constructor(props) {
        super(props);
        this.confirmPassword = this.confirmPassword.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleConfirmPassword = this.handleConfirmPassword.bind(this);
        this.handleResetPassword = this.handleResetPassword.bind(this);
        this.handlePasswordValid = this.handlePasswordValid.bind(this);
        this.handlerDoesPasswordMatch = this.handlerDoesPasswordMatch.bind(this);

        this.state = {
            resetCodeValid: false,
            isLinkedExpired: false,
            passwordUpdateSuccess: false,
            isPasswordValid: false,
            doesConfirmPasswordMatch: false,
            actionCode: "",
            confirmPassword: "",
            password: "",
            mode: ""
        };
    }

    componentDidMount() {
        const query = new URLSearchParams(window.location.search);
        this.actionCode = query.get('oobCode');
        this.setState({ actionCode: this.actionCode })
        this.mode = query.get('mode');
        this.handleResetPassword(this.actionCode)
    }


    confirmPassword(event) {
        event.preventDefault();
        if (this.state.isPasswordValid && this.state.doesConfirmPasswordMatch) {
            ReactGA.event({
                category: 'Login',
                action: 'Confirm Reset Password Button Click'
            });
            // Save the new password.
            firebase.auth().confirmPasswordReset(this.state.actionCode, this.state.password).then((resp) => {
                this.setState({ passwordUpdateSuccess: true });
            }).catch((error) => {
                this.setState({ isLinkedExpired: true });
                console.log("error on confirming password:", JSON.stringify(error));
                const errorMsg = JSON.stringify(error);
                ReactGA.event({
                    category: 'Login',
                    action: 'Confirm Reset Password Button Click Error',
                    label: errorMsg
                });
            });
        } else {
            this.setState({ doesConfirmPasswordMatch: false });
        }
    }

    handlePasswordValid() {
        const isValid = isPasswordValid(this.state.password);
        this.setState({ isPasswordValid: isValid });
    }

    handleResetPassword(actionCode) {
        if (actionCode) {
            firebase.auth().verifyPasswordResetCode(actionCode).then((email) => {
                this.setState({ resetCodeValid: true })
            }).catch((error) => {
                console.error("Error in handling password reset:", error)
                this.setState({ isLinkedExpired: true });
            });
        } else {
            this.setState({ isLinkedExpired: true });
        }
    }

    handlePassword(event) {
        this.setState({ password: event.target.value });
    }

    handleConfirmPassword(event) {
        this.setState({ confirmPassword: event.target.value });
    }

    handlerDoesPasswordMatch() {
        const doesMatch = this.state.confirmPassword === this.state.password;
        this.setState({ doesConfirmPasswordMatch: doesMatch });
        return doesMatch;
    }

    render() {
        ReactGA.pageview('/reset-password');
        return (
            <div>{(this.state.resetCodeValid && !this.state.passwordUpdateSuccess) && <div className="reset-password-form">
                <form id='password-form'>
                    <input type="password" placeholder="New Password" value={this.state.password} onChange={this.handlePassword} onBlur={this.handlePasswordValid} />
                    <input type="password" placeholder="Confirm Password" value={this.state.confirmPassword} onChange={this.handleConfirmPassword} onBlur={this.handlerDoesPasswordMatch} />
                </form>
                <div className='action-buttons'>
                    <form onSubmit={this.confirmPassword} id='reset-password-form' >
                        <input type="submit" value="Confirm Password" disabled={this.state.PasswordValid && this.state.doesConfirmPasswordMatch} />
                    </form>
                </div>
            </div>}
                {(!this.state.isPasswordValid && this.state.password.length > 0) && <div>Password doesn't meet minimum requirement. Make sure password is minimum 8 characters with both lower/uppercase, number and symbol.</div>}
                {(this.state.isPasswordValid && !this.state.doesConfirmPasswordMatch) && <div>The new Password and confirmation password do not match.</div>}
                {(this.state.passwordUpdateSuccess) && <div>Password updated successfully. Please <Link to='/login'>Login</Link></div>}
                {(this.state.isLinkedExpired) && <div>Link is expired and no longer valid. Please reset password again. <Link to='/forgot-password'>
                    <span>Forgot Password</span>
                </Link></div>}
            </div>
        );
    }
}

export default withRouter(PasswordResetHandler);

